import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { ClaimsService } from '../services/claims.service';
import { ClaimsStatusSearchHandler } from './claims-status-search.handler';

@Component({
  selector: 'sym-claims-status-search',
  templateUrl: './claims-status-search.component.html',
  styleUrls: ['./claims-status-search.component.scss'],
})
export class ClaimsStatusSearchComponent extends ClaimsStatusSearchHandler implements OnInit {
  constructor(
    public service: ClaimsService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, headerService, router, settingService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
